(function () {
  'use strict';

  angular
    .module('web2print')
    .factory('FileDownload', FileDownload);

  FileDownload.$inject = ['$http', '$translate', '$q', 'Common'];

  /* @ngInject */
  function FileDownload ($http, $translate, $q, Common) {
    let bufferContainer = '';
    const service = {
      getExampleFile: getExampleFile,
      getInvalidAddressDetails: getInvalidAddressDetails
    };

    return service;

    function convertAndDownload (response) {
      const fileName = response.name;
      const contentType = response.contentType;

      //convert base64 to byteString
      const byteString = atob(response.body || response.file);
      // write the bytes of the string to an ArrayBuffer
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab); //copied from NCP Claims, not sure what this does..
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      //create blob
      const blob = new Blob([ia], {
        type: contentType
      });

      const url = window.URL || window.webkitURL;

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const e = document.createEvent('MouseEvents');
        const a = document.createElement('a');
        a.download = fileName;
        a.href = window.URL.createObjectURL(blob);
        a.dataset.downloadurl = [contentType, a.download, a.href].join(':');
        e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        a.dispatchEvent(e);
        window.URL.revokeObjectURL(url); // clean the url.createObjectURL resource
      }

      bufferContainer = '';
    }

    function getExampleFile (toCountry, language) {
      const adType = Common.get('serviceType');

      const params = {
        language: pnTopbar.language,
        service: adType,
        market: pnTopbar.market
      };

      $http.get(web2print.env.recipientsBaseUrlV2 + 'getSampleFile', { params: params })
        .success(convertAndDownload)
        .error(function (error, response) {
          console.log('An error occured'); //FIXME, handle this, unlikely, but still
        });
    }

    function getInvalidAddressDetails (index, service, cb) {
      const param = {
        'id': Common.get('addressesFolderId', null),
        'index': index,
        'language': pnTopbar.language,
        'service': service
      };

      return $http.get(web2print.env.recipientsBaseUrlV2 + 'downloadInvalidDetails', { params: param })
        .success(function (response) {
          bufferContainer = bufferContainer + response.file;

          if (!response.isDone) {
            getInvalidAddressDetails(response.index + 1, service, cb);
            return;
          }

          response.file = bufferContainer;

          convertAndDownload(response);
          cb();
        })
        .error(function (err) {
          console.log(err);
          cb();
          return null;
        });
    }
  }
})();
